
const tableDescriptor = {
    model: 'table',//шаблон дескриптора
    title: 'tasks_archive',
    columns: [//описание столбцов таблицы
        {
          title: 'start time', //название столбца
          value: 'maps.startRT',//значение в строке, которое подтягивается в этот столбец
          dataKey: 'maps.startRT',//значение в строке, которое подтягивается в этот столбец (для jsPDF таблицы)
          filter: false,//фильтровать ли значения в данной колонке (для type == 'timestamp' фильтрация применяется независимо от этого флага)
          type: 'timestamp',//формат данных столбца
          width: '10%'//ширина столбца в % от 100
        },
        {
          title: 'end time',
          value: 'maps.endRT',
          dataKey: 'maps.endRT',
          type: 'timestamp',
          width: '10%'
        },
        // {
        //   title: 'time', //название столбца
        //   value: 'time',//значение в строке, которое подтягивается в этот столбец
        //   dataKey: 'time',//значение в строке, которое подтягивается в этот столбец (для jsPDF таблицы)
        //   filter: false,//фильтровать ли значения в данной колонке (для type == 'timestamp' фильтрация применяется независимо от этого флага)
        //   type: 'timestamp',//формат данных столбца
        //   width: '10%'//ширина столбца в % от 100
        // },
        {
          title: 'status',
          value: 'maps.status',
          translate: true,
          dataKey: 'status',
          filter: true,
          type: 'text',
          width: '10%',
          actions: [
            {
              // title: 'status',
              tooltip: 'status',
              icon: 'circle',
              // color: 'green',
              emit: 'no'
            },       
          ],
        },
        {
          title: 'command',
          value: 'maps.name',
          dataKey: 'name',
          filter: true,
          type: 'text',
          width: '15%'
        },
        {
          title: 'object',
          // title: 'device',
          value: 'maps.alternativename',
          dataKey: 'alternativename',
          filter: true,
          type: 'text',
          width: '20%'
        },
        {
          title: 'user',
          value: 'maps.user',
          dataKey: 'user',
          filter: true,
          type: 'text',
          width: '15%'
        },
        {
          title: 'processing',
          value: 'data.processing',
          dataKey: 'processing',
          filter: false,
          type: 'text',
          width: '30%'
        }
    ],

    pageLimit: 40,//количество строк на одной странице таблицы
    page: 1,//дефолтная страница
    nextPageButton: true,//вкл/выкл пагинатор

    sortable: false,//флаг вкл/выкл сортировки таблицы по столбцам
    subscribed: false,//флаг вкл/выкл подписки строк на статусы (раскрашивает строки в цвета статусов строк)
    ownStatus: true,//флаг вкл/выкл раскрашивает строки в цвета собственных статусов строк (subscribed == false)
    translate: true,//флаг вкл/выкл перевод (i18n) заголовков и значений
    toolbar: null,//добавляет дполонительный тулбар над шапкой таблицы (принимает строку как title. Это заготовка для размещения дополнительных функциональных элементов)   
    rowclick: true,//флаг определяет логику обработки click по ячейкам таблицы (true - клик на строку, false - клик на ячейку)
    removable: false,//добавляет столбец "действия" с кнопкой "удалить строку"
    resizable: false,//флаг вкл/выкл изменения размеров столбцов вручную (функционал требует допила)
    header: false,//флаг определяет позиционирование заголовков столбцов (внутри прокрутки или вне её)
    addButton: false,//добавляет кнопку "добавить" в заголовок первого столбца (используется для добавления внешних измерений в таблицу мониторинга устройства)
    activeActions: true,//вкл/выкл обработку событий "measureOff" для измерений
    hideState: [],//скрывает строки свойство state которых присутствует в массиве hideState. Принимает массив строк.
    hideValues: ['undefined'],//заменяет на '' (пустую строку) значения, приведенные в массиве hideValues. Принимает массив строк.

    filterBar: true,//флаг вкл/выкл фильтр бар

}

export default tableDescriptor